// Shared date math for the concierge's seasonal ordering — occasions and
// relationships both key off "how many days until this holiday". Pure calendar
// arithmetic, no product vocabulary, so it's safe to share (unlike per-variant
// copy, which each variant keeps its own).

// "About a month out" is the product rule for when a holiday starts influencing
// the suggestions.
export const SEASONAL_LEAD_DAYS = 35

const MS_PER_DAY = 86_400_000

export function nthSunday (year: number, month: number, nth: number): Date {
  const first = new Date(year, month, 1)
  const offset = (7 - first.getDay()) % 7
  return new Date(year, month, 1 + offset + (nth - 1) * 7)
}

export function daysUntil (dateForYear: (year: number) => Date, today: Date): number {
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const thisYear = dateForYear(start.getFullYear())
  const next = thisYear < start ? dateForYear(start.getFullYear() + 1) : thisYear
  return Math.round((next.getTime() - start.getTime()) / MS_PER_DAY)
}

// A calendar day sent as YYYY-MM-DD (the server's Date#iso8601), read back as local midnight so
// the day math above sees the same day everywhere. `new Date('2026-09-08')` would parse as UTC
// midnight, which is still the previous evening in every US zone.
export function localCalendarDate (isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number)
  return new Date(year, month - 1, day)
}
